import { Injectable } from '@angular/core';

import {
  ConfigService,
  EntityService
} from 'viggo-sistemas-core-web';

import { IPaciente } from '../models/paciente.model';

@Injectable()
export class PacienteService extends EntityService<IPaciente> {
  constructor(protected configService: ConfigService) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'paciente'
    });
  }
}
